export default function CSwitch() {
  return <h2>C Switch</h2>;
}
